import type ServiceApi from "../../api";
import type {MarketDataConstraints, MarketDataQueryInput, MarketDataResult} from "../../redux/marketDataInputSlice";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";

export type MarketDataRequest = Partial<MarketDataQueryInput> & {includeConstraints?: boolean};

export interface MarketDataResponse extends MarketDataResult {
    constraints?: MarketDataConstraints;
}

/**
 * API-Interface für die Angebots-Marktdaten einer Bewertung (POST {@link RevaApi.PATH_MARKETDATA}/revaId).
 */
export class MarketDataApiInterface extends SimpleApiInterface<MarketDataResponse> {
    constructor(
        private readonly revaId: string,
        private readonly query: MarketDataRequest,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_MARKETDATA, this.revaId]);
    }

    protected buildPayload(): MarketDataRequest {
        return this.query;
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<MarketDataResponse> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }
}
